import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

export const businessRouteChildren: RouteObject[] = [
  {
    path: '',
    Component: lazy(() => import('@/pages/Home')),
  },
  {
    path: 'product/category',
    Component: lazy(() => import('@/pages/Product/Category')),
  },
  {
    path: 'product/goods',
    Component: lazy(() => import('@/pages/Product/Goods')),
  },
  {
    path: 'news',
    Component: lazy(() => import('@/pages/News')),
  },
  {
    path: 'auth',
    Component: lazy(() => import('@/pages/Auth')),
  },
  {
    path: '*',
    Component: lazy(() => import('@/pages/404')),
  },
];

export const businessMenus: API.RoutersMenuItem[] = [
  {
    path: 'product',
    component: '',
    hidden: false,
    name: 'Product',
    meta: {
      title: '产品管理',
      icon: 'AppstoreOutlined',
      noCache: false,
      link: '',
    },
    children: [
      {
        path: 'category',
        component: 'product/category/index',
        hidden: false,
        name: 'ProductCategory',
        meta: {
          title: '产品分类',
          icon: 'ApartmentOutlined',
          noCache: false,
          link: '',
        },
      },
      {
        path: 'goods',
        component: 'product/goods/index',
        hidden: false,
        name: 'ProductGoods',
        meta: {
          title: '产品列表',
          icon: 'ShoppingOutlined',
          noCache: false,
          link: '',
        },
      },
    ],
  },
  {
    path: 'news',
    component: 'news/index',
    hidden: false,
    name: 'News',
    meta: {
      title: '新闻管理',
      icon: 'ReadOutlined',
      noCache: false,
      link: '',
    },
  },
];
